import React, { useState } from "react";
import { DeleteRowModal } from "../../../shared/helper/tableHelper";
import { Box, Button, Typography, Drawer, Tooltip } from "@mui/material";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import CardTrace from "./CardTraceFlowgraph.component";
import { useTranslation } from "react-i18next";

const TracesHistory = ({ agentPages, traces, handlePublish, handleDelete, userPermissions }) => {
  const [open, setOpen] = useState(false);
  const [deleteChange, setDeleteChange] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      {traces.length > 0 ? (
        <Button
          id="traces-history-button"
          onClick={() => setOpen(true)}
          variant="contained"
          sx={{
            position: "fixed",
            right: -40,
            top: "50%",
            paddingBottom: 1.5,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            transform: "translate(0%, -50%) rotate(-90deg)",
          }}>
          <KeyboardDoubleArrowUpIcon sx={{ marginRight: "10%" }} />
          {t("tracesHistory:buttonOpen")}
        </Button>
      ) : null}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ width: 500 }}>
        <Typography
          variant="h5"
          sx={{ textAlign: "center", marginTop: 2, marginBottom: 1 }}>
          {t("tracesHistory:title")}
        </Typography>
        <Box sx={{ width: 500, maxHeight: "80vh", overflowY: "auto" }}>
          {traces.map((trace) => (
            <CardTrace key={trace} trace={trace} agentPages={agentPages} />
          ))}
        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}>
          <Tooltip title={!userPermissions ? t("noPermissionTooltip") : ""}>
            <span>
              <Button
                id="traces-publish-button"
                variant="contained"
                disabled={!userPermissions}
                sx={{ width: "85%", marginLeft: "7.5%", marginTop: 2 }}
                onClick={() => {
                  handlePublish();
                  setOpen(false);
                }}>
                {t("tracesHistory:buttonPublish")}
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={!userPermissions ? t("noPermissionTooltip") : ""}>
            <span>
              <Button
                id="traces-delete-button"
                variant="contained"
                color="error"
                disabled={!userPermissions}
                sx={{ width: "85%", marginLeft: "7.5%", marginTop: 2 }}
                onClick={() => {
                  setDeleteChange(true);
                }}>
                {t("tracesHistory:buttonDelete")}
              </Button>
            </span>
          </Tooltip>
        </div>
      </Drawer>
      <DeleteRowModal
        title={t("tracesHistory:sureDelete")}
        open={deleteChange}
        onClose={() => {
          setDeleteChange(false);
        }}
        onDelete={() => {
          setOpen(false);
          setDeleteChange(false);
          handleDelete();
        }}
      />
    </div>
  );
};

export default TracesHistory;
